module.exports = __webpack_public_path__ + "img/kexue.b4d0500e.png";